import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-dropdown', 'close', 'Закрыть всплывающее окно');
Labels.set('ui-dropdown', 'closeLang', 'Закрыть выбор языка');
Labels.set('ui-dropdown', 'openLang', 'Открыть выбор языка');

Labels.set('ui-dropdown', 'eng', 'Английский');
Labels.set('ui-dropdown', 'est', 'Эстонский');
Labels.set('ui-dropdown', 'lat', 'Латышский');
Labels.set('ui-dropdown', 'lit', 'Литовский');
Labels.set('ui-dropdown', 'rus', 'Русский');
